import { modifier } from 'ember-modifier'

interface Signature {
  Args: {
    Named: {
      header?: boolean
      column?: boolean
      z?: string
      matchParentBackground?: boolean
    }
    Positional: unknown[]
  }
  Element: HTMLElement
}

export const sticky = modifier<Signature>(function (element, _positional, named) {
  if (named.header) {
    const topPosition = element.offsetTop

    element.style.top = `${topPosition}px`
  }

  if (named.column) {
    const leftPosition = element.offsetLeft

    element.style.left = `${leftPosition}px`
  }

  if (named.z) {
    element.style.zIndex = named.z
  }

  element.style.position = 'sticky'
})

export default sticky
